export enum EditorModeEnum {
    CreateTemplate,
    EditTempalte,
    EditProject,
}
